import React from 'react';
import useModal from '../../../hooks/useModal';
import windowService from '../../../services/windowService';
import { curriculumConfig } from '../models/curriculumConfig';
import {
  AgeGroup,
  AgeGroupButton,
  AgeGroups,
  AgeGroupSectionName,
  BibleStudyAgeGroupsProps,
  InlineBadge,
  SubscribedAgeGroupsSection,
} from './BibleStudyCardsElements';
import { UpcomingSubscriptionOverlay } from './UpcomingSubscriptionOverlay';

type UpcomingSubscriptionModalPayload = {
  brandName: string;
  renewalDate: string;
  brandCode: string;
  ageGroup: string;
};

export function BibleStudyAgeGroups({
  brandCode,
  brandName,
  subscribedAgeGroups,
  unsubscribedAgeGroups,
  recentlyPaired = [],
}: BibleStudyAgeGroupsProps) {
  const isOverviewEnabled = curriculumConfig.overviewEnabledCurriculum.includes(brandCode);

  const onSubscribeClick = (selectedBrandCode: string, ageId: string) => {
    return windowService.redirectTo(`#/subscribe-bible-study/${selectedBrandCode}/${ageId}`);
  };

  const [modal, openModal] = useModal(
    (type: string, payload: UpcomingSubscriptionModalPayload, dismissModal: () => void) => {
      if (!type) return null;
      return <UpcomingSubscriptionOverlay dismiss={dismissModal} {...payload} />;
    }
  );

  const openUpcomingModal = (name: string, renewalDate: string | undefined) =>
    openModal('upcoming', { brandName, renewalDate, brandCode, ageGroup: name });

  return (
    <>
      <SubscribedAgeGroupsSection
        sectionName="Subscribed Age Groups"
        brandCode={brandCode}
        entryRoute={isOverviewEnabled ? 'overview' : 'people'}
        subscribedAgeGroups={subscribedAgeGroups}
        recentlyPaired={recentlyPaired}
      />
      {unsubscribedAgeGroups.length > 0 && (
        <>
          {subscribedAgeGroups.length > 0 && <AgeGroupSectionName>More Age Groups</AgeGroupSectionName>}
          <AgeGroups>
            {unsubscribedAgeGroups.map(([name, accessInfo]) => (
              <AgeGroup key={accessInfo.id}>
                {accessInfo.access === 'Upcoming' ? (
                  <AgeGroupButton
                    data-qa-hook={`${brandCode}-${name}`}
                    aria-label={`${brandName} ${name} curriculum is upcoming`}
                    name={name}
                    onClick={() => openUpcomingModal(name, accessInfo.startDate)}
                    badgeComponent={<InlineBadge>Upcoming</InlineBadge>}
                  />
                ) : (
                  <AgeGroupButton
                    data-qa-hook={`${brandCode}-${name}`}
                    aria-label={`subscribe to ${brandName} ${name} curriculum`}
                    name={name}
                    onClick={() => onSubscribeClick(brandCode, accessInfo.id)}
                    badgeComponent={<InlineBadge>Subscribe</InlineBadge>}
                  />
                )}
              </AgeGroup>
            ))}
          </AgeGroups>
        </>
      )}
      {modal}
    </>
  );
}
